import React from 'react';
import PropTypes from 'prop-types';

export const AlertIcon = ({ fill = "#9E7200", className }) => (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.6336 4.93841C12.9065 3.6872 11.0935 3.6872 10.3664 4.93841L3.25624 17.1777C2.52917 18.4289 3.43565 20 4.8898 20H19.1102C20.5644 20 21.4708 18.4289 20.7438 17.1777L13.6336 4.93841ZM5.09154 18H18.9085L12 6.10797L5.09154 18Z" fill={fill} />
        <path d="M11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9Z" fill={fill} />
        <path d="M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z" fill={fill} />
    </svg>
);

AlertIcon.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/icons/AlertIcon.js